<template>
  <two-column-layout :class="rootClass">
    <pogs-list-cases slot="sidebar"
                       :patientcases="patientcases"
                       :patientCount="computedPatientCount"
                       @hideNav="hideNav"/>
  </two-column-layout>
</template>

<script>
  import {mapActions ,mapGetters, mapMutations} from 'vuex'

  import {
    GETTER_PATIENTS,
    ACTION_LOAD_PATIENT_CASES_LIST,
    ACTION_LOAD_OPENCASE_PATIENT_COUNT, GETTER_PATIENT_CASES, ACTION_LOAD_PATIENT_CASES_COUNT,
  } from '../../../store/modules/patients'

  import {GETTER_SHOW_PREVIEW, MUTATE_TOGGLE_PREVIEW, MUTATE_SHOW_PREVIEW} from '../../../store/modules/shared'
  import PogsListCases from './pogs-list--cases'

  import Permissions from '../../../mixins/permissions-mixin'
  import {ROOT_PATIENT_PERMISSIONS} from '../../../reference/pogs-functional-permissions'

  export default {
    mixins: [Permissions],
    components: {
      PogsListCases,
    },
    data(){
      return{
        numOfCases: null,
        numOfPatientWithOpenCase: null
      }
    },
    computed: {
      ...mapGetters({
        isPreview: GETTER_SHOW_PREVIEW,
        patients: GETTER_PATIENTS,
        patientcases: GETTER_PATIENT_CASES
      }),
      rootClass(){
        return 'hide-content'
      },
      computedPatientCount() {
        return {
          all: this.numOfCases,
          withOpenCase: this.numOfPatientWithOpenCase
        }
      }
    },
    methods: {
      ...mapMutations({
        togglePreview: MUTATE_TOGGLE_PREVIEW,
        setPreview: MUTATE_SHOW_PREVIEW
      }),
      ...mapActions({
        loadNumOfPatientCases: ACTION_LOAD_PATIENT_CASES_COUNT,
        loadNumOfOpenCases: ACTION_LOAD_OPENCASE_PATIENT_COUNT
      }),
      hideNav() {
          this.$emit('hideNav')
      }
    },
    mounted() {
      if(this.hasPermissionFor(ROOT_PATIENT_PERMISSIONS)){
        console.log('The user has access to patient page')
      }else{
        console.log('The user has no access to patient page')
      }

      this.$store.dispatch(ACTION_LOAD_PATIENT_CASES_LIST, {tag: "openCase"})
        .then((data) => {
          console.log("Cases list has been successfully loaded!")
        });


      this.loadNumOfPatientCases()
        .then((result) => {
          this.numOfCases = result.numOfCases
        });

      this.loadNumOfOpenCases()
        .then((result) => {
          this.numOfOpenCases = result.numOfOpenCases
        });

    }
  }
</script>

  <style lang="scss">

    @media (max-width: 850px) {
      .show-content .content {
          grid-area: app__status !important;
      }
    }
    @media (max-width: 376px) {
      .patient-data__details > .patient-data__meta {
        padding-top: 5px;
        grid-template-columns: unset;
        grid-template-rows: 20px 20px;
        grid-column-gap: 0;
      }
    }
  </style>
